import React from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useCart } from '../context/CartContext';
import BrandLogo from './BrandLogo';

export default function Navbar() {
  const navigate = useNavigate();
  const cart = (() => {
    try { return useCart(); } catch { return null; }
  })();
  const totalItems = cart ? cart.items.reduce((s, i) => s + Number(i.quantity), 0) : 0;
  const jwt = localStorage.getItem('jwt');

  const handleLogout = () => {
    localStorage.removeItem('jwt');
    localStorage.removeItem('user');
    navigate('/login');
    window.location.reload();
  };

  return (
    <nav className="sticky top-0 z-50 bg-rs-darker/90 backdrop-blur-md border-b border-rs-border shadow-[0_1px_20px_rgba(225,6,0,0.15)]">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex justify-between items-center h-20">
          <Link to="/" className="flex items-center group">
            <BrandLogo size="md" />
          </Link>

          <div className="flex items-center gap-4 sm:gap-6">
            <Link
              to="/cart"
              className="relative flex items-center gap-2 px-3 py-2 rounded-lg text-gray-300 hover:bg-rs-surfaceLight hover:text-rs-accent transition-colors"
            >
              <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 3h2l.4 2M7 13h10l4-8H5.4M7 13L5.4 5M7 13l-2.293 2.293c-.63.63-.184 1.707.707 1.707H17m0 0a2 2 0 100 4 2 2 0 000-4zm-8 2a2 2 0 11-4 0 2 2 0 014 0z" />
              </svg>
              <span className="hidden sm:inline">Carrito</span>
              {totalItems > 0 && (
                <span className="absolute -top-1 -right-1 flex items-center justify-center bg-rs-accent text-white text-xs font-bold rounded-full min-w-[20px] h-5 px-1.5 shadow-glow">
                  {totalItems}
                </span>
              )}
            </Link>

            {jwt ? (
              <>
                <Link
                  to="/dashboard"
                  className="px-3 py-2 rounded-lg text-gray-300 hover:bg-rs-surfaceLight hover:text-rs-accent transition-colors font-medium"
                >
                  Panel
                </Link>
                <button
                  onClick={handleLogout}
                  className="px-3 py-2 rounded-lg text-gray-300 hover:bg-red-500/20 hover:text-red-400 transition-colors font-medium"
                >
                  Cerrar sesión
                </button>
              </>
            ) : (
              <>
                <Link
                  to="/register"
                  className="px-3 py-2 rounded-lg text-gray-300 hover:bg-rs-surfaceLight hover:text-rs-accent transition-colors"
                >
                  Registrarse
                </Link>
                <Link
                  to="/login"
                  className="px-4 py-2 rounded-lg bg-rs-accent text-white font-semibold hover:bg-rs-accentHover transition-colors shadow-glow"
                >
                  Iniciar sesión
                </Link>
              </>
            )}
          </div>
        </div>
      </div>
    </nav>
  );
}
